import React from 'react';
import {ReactComponent as BasketIcon} from '../../../../../../../assets/main/groups/online/basket.svg';
import {ReactComponent as ArrayRightIcon} from '../../../../../../../assets/main/groups/main-table/array-right.svg';
import {TestItem} from "features/model/types/lessons/lessons-test/lessonsTest";
import {NavLink, useParams} from "react-router-dom";
import {deleteLessonsTest} from "features/model/service/lessons/lessons-test/delete-lessons-test/deleteLessonsTest";
import {useAppDispatch, useAppSelector} from "common/hook";
import {ROLE_TEACHER} from "entities/constants/constants";


interface ILessonsTestItems {
    item: TestItem;
}

export const TestItems = ({item}: ILessonsTestItems) => {
    const {lessonsId} = useParams()
    const dispatch = useAppDispatch()
    const roleType = useAppSelector((state) => state.role.roleType);
    const userId = useAppSelector((state) => state.profile.data?.id);
    const statusText = item.status === 'done' ? 'Пройден' : item.status === 'notDone' ? 'Не пройден' : 'Ожидает выполнения';


    const onClickHandler = (testId: number | undefined) => {
        if (testId) {
            dispatch(deleteLessonsTest({lessonsId, testId}));
        }
    };


    return (
        <div className="row" key={item.id}>
            <div className="col group-name-col full-width-mobile">
                <span className="col-title">Тест</span>
                <p>
                    <NavLink to={`/test/${item.id}${item.status === 'done' ? `/view-answer/${userId}` : ''}`}>
                        {item.title}
                    </NavLink>{" "}
                </p>

            </div>
            <div className="col group-col full-width-mobile">
                <span className="col-title">Автор</span>
                <p>{item.author}</p>
            </div>


            {roleType === ROLE_TEACHER && (
                <>
                    <div className="col students-col">
                        <span className="col-title">Студенты</span>
                        <div className="students-number">
                            {item.students.map((student, index) => (
                                <div className="avatar" key={index}>
                                    <img src={student.key} alt={`Student ${index + 1}`}/>
                                </div>
                            ))}
                            <span className="num">{item.studentsCount}</span>
                        </div>
                    </div>
                    <div className="col passed-test-col align-right">
                        <span className="col-title">Прошли тест</span>
                        <a href='#' style={{boxShadow: 'none'}}>
                            {item.testPassed}
                            {/*<a href={item.testLink}>{item.testPassed}</a>*/}
                        </a>
                    </div>

                    <div className='col delete-col' onClick={() => onClickHandler(item.id)}>
                <span className='delete-tbl-row'>
                    <BasketIcon/>
                </span>
                    </div>
                </>
            )}
            <NavLink to={`/test/${item.id}${item.status === 'done' ? `/view-answer/${userId}` : ''}`}>
                <div className="col btn-link-col">
                    <span className="circle-arrow-btn">
                         <ArrayRightIcon/>
                    </span>
                </div>
            </NavLink>
        </div>
    );
};
